/**
 * Whether the container has a react-aria or native popover currently open.
 *
 * Checks for [aria-expanded="true"] on any descendant — the same heuristic
 * used in editable-cell.tsx:919-921 to decide whether Enter should be passed
 * through to a dropdown or date picker instead of triggering a cell commit.
 *
 * Exported separately from useInlineEdit because the proposals surface
 * consumes it without the hook (to gate its own outside-click logic).
 */
export function isPopoverOpenWithin(container: Element | null): boolean {
  return container?.querySelector('[aria-expanded="true"]') != null;
}
